import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  DownloadButton,
  downloadReport
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './index';

const FeesNotApprovedReport = ({ data }) => {
  const [sellerId, setSellerId] = useState();

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'fees-not-approved-report',
      params: { 'seller-id': sellerId }
    })
  }

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Fees Not Approved Report</Text>
      <Text style={styles.label}>Seller:</Text>
      <select style={styles.select} onChange={e => setSellerId(e.target.value)}>
        <option value="">Select Seller</option>
        {data.sellers?.map(seller => (
          <option key={seller.id} value={seller.id}>
            {seller.fullDisplayName}
          </option>
        ))}
      </select>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
};

export default FeesNotApprovedReport;
